module.exports = __webpack_public_path__ + "static/img/1_8_1.b1b54937.jpg";